import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { logoutTeamMember } from "~/providers/api";
import { useUiStore } from "~/providers/stores";

export const useLogoutTeamMember = () => {
  const { setSideBarOpen } = useUiStore();
  const queryClient = useQueryClient();

  const { mutate: logoutMutation, isPending } = useMutation({
    mutationFn: logoutTeamMember,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["getTeamMemberIsAuth"],
        exact: true,
      });
      queryClient.clear();
      setSideBarOpen(false);
    },
    onError: () =>
      toast.error(
        "An error occurred while trying to log out. Please try again later.",
      ),
  });

  return { logoutMutation, isPending };
};
